// Shared bindings and existing account macros have separate persistence channels.
// Publishing, following, restoring and exporting a shared profile never touch macros.
export function combineCommandPreferenceChannels(shortcuts, account) {
  const get = () => {
    const shared = shortcuts.get(), local = account.get()
    if (shared.status === 'unlinked') return local
    return { ...shared, macros: local.macros, macroStatus: local.status,
      macroInvalidCount: local.invalidCount, macroCacheFailed: local.cacheFailed,
      canEdit: shared.canEdit && local.canEdit }
  }
  async function edit(update) {
    if (shortcuts.get().status === 'unlinked') return account.edit(update)
    const current = get()
    if (!current.canEdit) return false
    const next = update({ bindings: current.bindings, macros: current.macros })
    const bindingsChanged = JSON.stringify(next.bindings) !== JSON.stringify(current.bindings)
    const macrosChanged = JSON.stringify(next.macros) !== JSON.stringify(current.macros)
    // Ordinary UI actions edit one channel at a time. Reject an ambiguous combined
    // mutation instead of claiming an atomic save across independent stores.
    if (bindingsChanged && macrosChanged) return false
    if (macrosChanged) return account.edit(value => ({ ...value, macros: next.macros }))
    if (bindingsChanged) return shortcuts.edit(() => ({ bindings: next.bindings }))
    return true
  }
  return {
    ...shortcuts, get, edit,
    refresh: async () => (await Promise.all([shortcuts.refresh(), account.refresh()])).every(Boolean),
    reloadMacros: () => account.useAccount(),
    useAccount: () => shortcuts.get().status === 'unlinked' ? account.useAccount() : shortcuts.useAccount(),
    importDocument: value => shortcuts.get().status === 'unlinked' ? account.importDocument(value) : shortcuts.importDocument(value),
    importLegacy: () => shortcuts.get().status === 'unlinked' ? account.importLegacy() : shortcuts.importLegacy(),
    activate() { shortcuts.activate(); account.activate() },
    dispose() { shortcuts.dispose(); account.dispose() },
  }
}
